// extracted by mini-css-extract-plugin
export var title = "return-module--title--d2ZkP";
export var textContainer = "return-module--textContainer--YWszc";